import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { SectionHeading } from './SectionHeading';
import type { IndustryCard } from '../../types/product';
type IndustryCardsProps = {
  heading: string;
  subheading: string;
  items: IndustryCard[];
};
export function IndustryCards({
  heading,
  subheading,
  items
}: IndustryCardsProps) {
  return <section className="w-full bg-canvas-sky py-20" aria-labelledby="industries-heading" data-id="element-1069" data-mp="3hxparb7qddpo">
      <div className="mx-auto max-w-shell px-6" data-id="element-1070" data-mp="3mwip15uud8qw">
        <SectionHeading id="industries-heading" title={heading} subtitle={subheading} data-id="element-1071" data-mp="3mv7l961ec0zs" />
        <ul className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1072" data-mp="3roa9cynemi8l">
          {items.map(item => <li key={item.title} data-id="element-1073" data-mp="gekdvql4wsd">
              <SmartLink href={item.href} className="group flex h-full flex-col" data-id="element-1074" data-mp="5g0w20qrm4z2">
                <div className="overflow-hidden rounded-[12px]" data-id="element-1075" data-mp="5dxxgsbjr3iq">
                  <img src={item.image} alt={item.alt} loading="lazy" className="h-[200px] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-1076" data-mp="9ifdqhip6yor" />
                </div>
                <h3 className="mt-5 text-[18px] font-semibold tracking-[-0.02em] text-ink" data-id="element-1077" data-mp="3elp132qdj28l">{item.title}</h3>
                <p className="mt-1.5 text-[14px] leading-[1.5] text-ink-muted" data-id="element-1078" data-mp="39ndquqw62ppu">{item.copy}</p>
                <span className="mt-auto inline-flex items-center gap-1.5 pt-4 text-[14px] font-medium text-brand" data-id="element-1079" data-mp="b2vs738jj1kr">
                  Explore solution
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1080" data-mp="1e410xbb0law" />
                </span>
              </SmartLink>
            </li>)}
        </ul>
      </div>
    </section>;
}